import React from 'react';

import { LinearProgress, withStyles } from '@gogame/components';

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 4,
    borderRadius: 2,
  },
  colorPrimary: {
    backgroundColor: theme.palette.action.selected,
  },
  bar: {
    borderRadius: 2,
    backgroundColor: theme.palette.warning.main,
  },
}))(LinearProgress);

export const StatisticProgress = ({ variant = 'determinate', value = 0 }) => {
  return <BorderLinearProgress variant={variant} value={value} />;
};
